var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { UrlHelper } from '../../../helper/UrlWrapper';
import { mapGetters } from 'vuex';
import businessStockService from "../../../api/SalesReportService";
var stockHeader = (function (_super) {
    __extends(stockHeader, _super);
    function stockHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            business_id: '',
            supplier_to_business_id: '',
            business_scm_id: '',
            shop_city_ids: null,
            shop_type_id: '',
            shop_ids: [],
            goods_type_ids: [],
            keyword: '',
            unit_type: 'amount',
            stock_type: '1'
        };
        _this.categoryData = [];
        _this.customerSourceOptions = [];
        _this.areaList = [];
        _this.customerTypeOptions = [];
        _this.depotList = [];
        _this.goodsTypeList = [];
        _this.clientList = [];
        return _this;
    }
    stockHeader.prototype.watchBusiness = function (newVal, oldVal) {
        if (newVal) {
            this.selectClient();
        }
    };
    stockHeader.prototype.created = function () {
        this.service = businessStockService.getInstance();
    };
    stockHeader.prototype.normalizer = function (id, name) {
        if (id === void 0) { id = "id"; }
        if (name === void 0) { name = "name"; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    stockHeader.prototype.normalizergood = function (node) {
        return function (node) { return ({
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        }); };
    };
    stockHeader.prototype.normalizerShop = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    stockHeader.prototype.getbusinessList = function () {
        var _this = this;
        this.service.getbusinessStock().then(function (res) {
            console.log(777, res.data);
            _this.clientList = Array.isArray(res.data.data) ? res.data.data : [];
            _this.formData.business_id = res.data.data[0].business_id;
            _this.formData.business_scm_id = res.data.data[0].business_scm_id;
            _this.formData.supplier_to_business_id = res.data.data[0].supplier_to_business_id;
            _this.$emit('sendBusinessId', _this.formData.business_id);
        });
    };
    stockHeader.prototype.selectClient = function () {
        this.getClientType();
        this.getClientGoodsType();
        this.getClientStore();
    };
    stockHeader.prototype.getClientType = function () {
        var _this = this;
        this.service.getClientType({ business_id: this.formData.business_id }).then(function (res) {
            console.log(66666, res.data);
            _this.customerTypeOptions = Array.isArray(res.data.data) ? res.data.data : [];
        });
    };
    stockHeader.prototype.getbusinessArea = function () {
        var _this = this;
        this.service.getbusinessArea().then(function (res) {
            var area = Array.isArray(res.data.data) ? [res.data.data[0]] : [];
            _this.areaList = [area[0]];
        });
    };
    stockHeader.prototype.areaChange = function (value, instanceId) {
        this.formData.shop_city_ids = value.id;
    };
    stockHeader.prototype.shopChange = function (value, instanceId) {
        console.log('shopChange', value, instanceId);
    };
    stockHeader.prototype.getClientStore = function () {
        var _this = this;
        var business_id = this.formData.business_id;
        var params = {
            'business_id': business_id,
            'supplier_to_business_id': this.formData.supplier_to_business_id,
        };
        this.service.getClientStore(params).then(function (res) {
            _this.depotList = Array.isArray(res.data.data) ? res.data.data : [];
        });
    };
    stockHeader.prototype.getClientGoodsType = function () {
        var _this = this;
        var params = {
            business_id: this.formData.business_id,
            supplier_to_business_id: this.formData.business_id,
            business_scm_id: this.formData.business_scm_id,
        };
        this.service.getClientGoodsType(params).then(function (res) {
            _this.goodsTypeList = Array.isArray(res.data.data) ? res.data.data : [];
        });
    };
    stockHeader.prototype.searchClick = function () {
        this.$emit('search', this.formData);
    };
    stockHeader.prototype.reset = function () {
        this.formData = {
            business_id: this.clientList[0].business_id,
            shop_city_ids: '',
            shop_type_id: '',
            shop_ids: [],
            goods_type_ids: [],
            keyword: '',
            unit_type: 'amount',
            stock_type: '1'
        };
    };
    stockHeader.prototype.exportData = function () {
        var url = "supplierclientapi/report/business_stock_export?";
        url = UrlHelper.addParam(url, 'business_id', this.formData.business_id);
        url = UrlHelper.addParam(url, 'supplier_to_business_id', this.formData.supplier_to_business_id);
        url = UrlHelper.addParam(url, 'shop_city_ids', this.formData.shop_city_ids ? this.formData.shop_city_ids : '');
        url = UrlHelper.addParam(url, 'shop_type_id', this.formData.shop_type_id);
        url = UrlHelper.addParam(url, 'shop_ids', this.formData.shop_ids.join(','));
        url = UrlHelper.addParam(url, 'goods_type_ids', this.formData.goods_type_ids.join(','));
        url = UrlHelper.addParam(url, 'keyword', this.formData.keyword);
        url = UrlHelper.addParam(url, 'unit_type', this.formData.unit_type);
        url = UrlHelper.addParam(url, 'stock_type', this.formData.stock_type);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(['_trackEvent', '', '客户库存查询导出结果']);
    };
    stockHeader.prototype.mounted = function () {
        this.getbusinessList();
        this.getbusinessArea();
    };
    __decorate([
        Watch('formData.supplier_to_business_id')
    ], stockHeader.prototype, "watchBusiness", null);
    stockHeader = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
        })
    ], stockHeader);
    return stockHeader;
}(Vue));
export default stockHeader;
